import React from 'react';
import { useNavigate } from 'react-router-dom';

function YatirimPage() {
  const navigate = useNavigate();

  const services = [
    {
      title: "Yatırım Danışmanlığı",
      description: "Profesyonel yatırım danışmanlarımız ile yatırım hedeflerinize ulaşın.",
      icon: "📊"
    },
    {
      title: "Aracılık Hizmetlerimiz",
      description: "Borsa İstanbul'da hisse senedi alım satım işlemleriniz için aracılık hizmeti.",
      icon: "🏦"
    },
    {
      title: "Portföy Yönetimi",
      description: "Profesyonel portföy yönetimi ile yatırımlarınızı değerlendirin.",
      icon: "💼"
    },
    {
      title: "Türev Araçlar",
      description: "Vadeli işlemler ve opsiyon piyasalarında işlem yapın.",
      icon: "📈"
    },
    {
      title: "VİOP Hizmetlerimiz",
      description: "Vadeli İşlem ve Opsiyon Borsasında aracılık hizmetleri.",
      icon: "⚡"
    },
    {
      title: "Fon Yönetimi",
      description: "Yatırım fonları ile tasarruflarınızı değerlendirin.",
      icon: "💰"
    },
    {
      title: "Araştırma",
      description: "Piyasa analizleri ve araştırma raporları.",
      icon: "🔍"
    },
    {
      title: "Kurumsal Finansman",
      description: "Halka arz, birleşme ve satın alma danışmanlığı.",
      icon: "🏢"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Yatırım Hizmetleri</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-3xl font-bold text-[#1e5a8e] mb-4">Yatırım Hizmetlerimiz</h2>
          <p className="text-gray-600 leading-relaxed">
            Sermaye Piyasası Kurulu'ndan aldığımız Alım Satım Aracılığı Yetki Belgesi ile 
            Borsa İstanbul Hisse Senetleri Piyasası'nda faaliyet göstermekteyiz. Bireysel ve 
            kurumsal yatırımcılara kapsamlı aracılık hizmetleri sunmaktayız.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer">
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-[#1e5a8e] mb-3">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
              <button className="mt-4 text-[#26c6da] font-semibold hover:text-[#1e5a8e] transition-colors">
                Detaylı Bilgi →
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default YatirimPage;
